import { noStandardsCss } from "./NoStandardsFound.styles";

export const NoStandardsFound = () => (
  <div css={noStandardsCss}>
    No standards were found. Please try again with a different search query or
    filter.
  </div>
);
